import { Mail } from 'lucide-react';

const ContactForm = () => {
  return (
    <div className="group bg-neutral-white rounded-xl shadow-xl border border-neutral-border p-8 overflow-hidden">
      <div className="h-1 bg-gradient-to-r from-success-primary to-action-primary -mx-8 -mt-8 mb-6"></div>

      <div className="text-center py-4">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-trust-light mb-4">
          <Mail size={28} className="text-trust-primary" />
        </div>
        <h3 className="text-2xl font-bold text-authority-navy mb-3">We&rsquo;re no longer scheduling service</h3>
        <p className="text-neutral-gray leading-relaxed max-w-md mx-auto mb-6">
          Colorado First Plumbing and Sewer LLC permanently closed in March 2026. Thank you for 8 unforgettable years of trust. For general inquiries, please email us directly:
        </p>
        <a
          href="mailto:contact@bestmasterplumber.com"
          className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-r from-trust-primary to-trust-deep text-white font-semibold hover:shadow-xl hover:scale-[1.02] transition-all duration-300"
        >
          <Mail size={18} className="mr-2" />
          contact@bestmasterplumber.com
        </a>
      </div>
    </div>
  );
};

export default ContactForm;
